import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeCommissionPayee } from 'bundles/apex/deals/form/store/deal/actions';

import BrokerGrossCommissionWrapper from 'bundles/apex/deals/form/fields/broker_gross_commission/wrapper';
import ContactSelector from 'bundles/backoffice/contacts/selector';
import { horizontalFormStyles } from 'helpers/react_select_helpers';

export function OutsideBroker({ changeCommissionPayee, commission, required, transactionSide }) {
  return (
    <BrokerGrossCommissionWrapper
      commission={commission}
      label="Outside Broker"
      required={required}
      transactionSide={transactionSide}
      visibleOverflow
    >
      <ContactSelector
        contact={commission.contact}
        disabled={!!commission.id}
        styles={horizontalFormStyles}
        onChange={contact => changeCommissionPayee(commission, { contact }, transactionSide)}
      />
    </BrokerGrossCommissionWrapper>
  );
}

OutsideBroker.propTypes = {
  changeCommissionPayee: PropTypes.func.isRequired,
  commission: PropTypes.shape({
    contact: PropTypes.object,
    id: PropTypes.number,
  }).isRequired,
  primary: PropTypes.bool,
  required: PropTypes.bool,
  transactionSide: PropTypes.string,
};

const mapDispatchToProps = {
  changeCommissionPayee,
};

export default connect(null, mapDispatchToProps)(OutsideBroker);
